import { stitchDefaults } from './defaults';
import SpotlightGameModel from '../models/SpotlightGameModel';

export default {
    ...stitchDefaults,
    model: SpotlightGameModel,
    expires: 60,
    pathTemplate: 'bdfed/spotlight-game/{locale:en-US}?gamePk={gamePk}'
};
